import { readDomIdle, cancelFastDom } from 'gleam-shared/browser/fastDom'

const map = new WeakMap()
const addListener = globalThis.addEventListener
const removeListener = globalThis.removeEventListener

globalThis.addEventListener = throttlingAddListener
globalThis.removeEventListener = throttlingRemoveListener

function throttlingAddListener(event, action, options) {
  // the only script on the page that would subscribe
  // onto "scroll" and "resize" without passing the options is GA,
  // which causes forced reflows by reading DOM before the layout is calculated

  if (options || (event !== 'scroll' && event !== 'resize')) {
    return addListener(event, action, options)
  }

  if (map.has(action)) {
    return
  }

  const wrappedAction = function wrappedGaAction() {
    readDomIdle(action)
  }

  map.set(action, wrappedAction)
  addListener(event, wrappedAction, { passive: true })
}

function throttlingRemoveListener(event, action) {
  if (!map.has(action)) {
    return removeListener(event, action)
  }

  const wrappedAction = map.get(action)

  cancelFastDom(action)
  map.delete(action)
  removeListener(event, wrappedAction)
}
